import api from "../services/api";

export const fetchScheduleDraft = async ({ ticketId, contactId }) => {
  const { data } = await api.get("/schedules/draft", {
    params: {
      ...(ticketId ? { ticketId } : {}),
      ...(contactId ? { contactId } : {}),
    },
  });
  return data;
};

export const saveScheduleDraft = async ({ ticketId, contactId, payload }) => {
  const { data } = await api.put("/schedules/draft", {
    ticketId: ticketId || null,
    contactId: contactId || null,
    payload,
  });
  return data;
};

export const deleteScheduleDraft = async ({ ticketId, contactId }) => {
  const { data } = await api.delete("/schedules/draft", {
    params: {
      ...(ticketId ? { ticketId } : {}),
      ...(contactId ? { contactId } : {}),
    },
  });
  return data;
};
